import { Injectable } from '@angular/core';
import { NpaId } from '@circe/core';

@Injectable() export class TableService {
  public tables: Record<NpaId, Record<NpaId, any>> = {};

  constructor() {}

  private _checkExists(tableId: NpaId, columnId: NpaId, asArray: boolean = false): void {
    if (!this.tables[tableId]) {
      this.tables[tableId] = {};
    }
    if (!this.tables[tableId][columnId]) {
      this.tables[tableId][columnId] = asArray ? [] : {};
    }
  }

  public addCheckboxData(tableId: NpaId, rowId: NpaId, columnId: NpaId): void {
    if (!this.tables[tableId]) {
      this.tables[tableId] = {};
    }
    if (!this.tables[tableId][columnId]) {
      this.tables[tableId][columnId] = [];
    }
    this.tables[tableId][columnId].push(rowId);
  }

  public setRadioData(tableId: NpaId, rowId: NpaId, columnId: NpaId): void {
    this._checkExists(tableId, columnId);
    this.tables[tableId][columnId] = rowId;
  }

  public setSelectData(tableId: NpaId, rowId: NpaId, columnId: NpaId, value: any): void {
    this._checkExists(tableId, columnId);
    if (!this.tables[tableId][columnId][rowId]) {
      this.tables[tableId][columnId][rowId] = {};
    }
    this.tables[tableId][columnId][rowId] = value;
  }

  public deleteCheckboxData(tableId: NpaId, rowId: NpaId, columnId: NpaId): void {
    this._checkExists(tableId, columnId, true);
    this.tables[tableId][columnId] = this.tables[tableId][columnId].filter((id: NpaId) => id !== rowId);
  }

  public getColumnData(tableId: NpaId, columnId: NpaId): Record<NpaId, any> | NpaId[] {
    const _table: Record<NpaId, any> = this.tables[tableId];
    return _table[columnId] ? _table[columnId] : {};
  }
}
